<div class="row animate__animated animate__backInDown">
  <div class="col-12">
    <div class="card mb-2 h-auto">
      <div class="user-profile-header-banner">
        <img
          src="../../assets/img/pages/profile-banner.png"
          alt="Banner image"
          class="rounded w-100"
        />
        <div class="flex-shrink-0 mt-n2 mx-sm-0 mx-auto picture-box">
          <img
            (error)="userProfile.imageurl='../../assets/img/avatars/no-image.png'"
            [src]="userProfile.imageurl"
            alt="user image"
            class="d-block ms-0 ms-sm-4 rounded-3 user-profile-img h-100"
          />
          <label class="btn btn-icon btn-outline-primary position-absolute bottom-0 end-0" for="file">
              <i class="far fa-edit"></i>
          </label>
          <input type="file" id="file" [(ngModel)]="uploadImage" (change)="handleFileInput($event)" hidden>
         
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="mb-4 col-6">
    <div class="card animate__animated animate__fadeInDown animate__delay-3-2s">
      <div class="card-body">
        <small class="text-muted text-uppercase">
          {{ "PersonalInfo" | translate }}
        </small>
        <div class="row">
          <div class="col-6 pt-3">
            <div class="edit-form">
              <label class="form-label" for="user-profile-firstname">
                <i class="fas fa-user"></i>
                {{ "FirstName" | translate }}
              </label>
              <div class="validation-alert-input">
                <p>{{ userProfile.firstNameValidation }}</p>
              </div>
              <input
                id="user-profile-firstname"
                class="input-design form-control"
                [ngClass]="{ 'is-invalid': userProfile.firstNameValidation }"
                type="text"
                [(ngModel)]="userProfile.firstName"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-6 pt-3">
            <div class="edit-form">
              <label class="form-label" for="user-profile-lastname">
                <i class="fas fa-user-friends"></i>
                {{ "LastName" | translate }}
              </label>
              <div class="validation-alert-input">
                <p>{{ userProfile.lastNameValidation }}</p>
              </div>
              <input
                id="user-profile-lastname"
                class="input-design form-control"
                [ngClass]="{ 'is-invalid': userProfile.lastNameValidation }"
                type="text"
                [(ngModel)]="userProfile.lastName"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-6 pt-3">
            <div class="edit-form">
              <label class="form-label" for="user-profile-birthday">
                <i class="fas fa-birthday-cake"></i>
                {{ "BirthDate" | translate }}
              </label>
              <div class="validation-alert-input">
                <p>{{ userProfile.birthdayValidation }}</p>
              </div>
              <div class="datepicker-box">
                <input
                  id="user-profile-birthday"
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': userProfile.birthdayValidation }"
                  [ngModel]="userProfile.birthday | dataType : '' : false"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="YYYY/MM/DD"
                  (ngModelChange)="deliveryTypeDate()"
                />
                <button
                  [ngbPopover]="popoverDatapickerfactorDate"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
              <ng-template #popoverDatapickerfactorDate>
                <app-data-picker
                  [(childProp)]="userProfile.birthday"
                  (changeVariableMonth)="changeMonth($event)"
                ></app-data-picker>
              </ng-template>
            </div>
          </div>
          <div class="col-6 pt-3">
            <div class="edit-form">
              <label class="form-label" for="user-profile-national-code">
                <i class="far fa-address-card"></i>
                {{ "NationalCode" | translate }}
              </label>
              <div class="validation-alert-input">
                <p>{{ userProfile.nationalCodeValidation }}</p>
              </div>
              <input
                id="user-profile-national-code"
                class="input-design form-control"
                [ngClass]="{ 'is-invalid': userProfile.nationalCodeValidation }"
                type="text"
                [(ngModel)]="userProfile.nationalCode"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-6 pt-3">
            <div class="edit-form">
              <label class="form-label" for="user-profile-mobile-number">
                <i class="fas fa-mobile-alt"></i>
                {{ "MobileNumber" | translate }}
              </label>
              <div class="validation-alert-input">
                <p>{{ userProfile.mobileNumberValidation }}</p>
              </div>
              <input
                id="user-profile-mobile-number"
                class="input-design form-control"
                type="text"
                [ngClass]="{ 'is-invalid': userProfile.mobileNumberValidation }"
                [(ngModel)]="userProfile.mobileNumber"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-6 pt-3">
            <div class="edit-form">
              <label class="form-label" for="user-profile-phone-number">
                <i class="fas fa-phone"></i>
                {{ "phone" | translate }}
              </label>
              <div class="validation-alert-input">
                <p>{{ userProfile.phoneNumberValidation }}</p>
              </div>
              <input
                id="user-profile-phone-number"
                class="input-design form-control"
                type="text"
                [ngClass]="{ 'is-invalid': userProfile.phoneNumberValidation }"
                [(ngModel)]="userProfile.phoneNumber"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>

          <div class="col-12 pt-3">
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-primary"
                (click)="UpdateProfile()"
              >
                <i class="far fa-save"></i>
                {{ "Save" | translate }}
              </button>
            </div>
          </div>
        </div>
        <app-loading-panel *ngIf="loadingUser"></app-loading-panel>
      </div>
    </div>
  </div>
  <div class="mb-4 col-3">
    <div class="card animate__animated animate__fadeInDown animate__delay-3-6s">
      <div class="card-body">
        <small class="text-muted text-uppercase">
          {{ "FurtherInformation" | translate }}
        </small>

        <ul class="list-unstyled mb-4 mt-3">
          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-user-cog"></i>
            <span class="fw-semibold mx-2">
              {{ "Username" | translate }} :
            </span>
            <span>{{ userProfile.username }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-user-tag"></i>
            <span class="fw-semibold mx-2">
              {{ "RoleName" | translate }} :
            </span>
            <span>{{ userProfile.roleName }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-briefcase"></i>
            <span class="fw-semibold mx-2">
              {{ "Position" | translate }} :
            </span>
            <span>{{ userProfile.positionName }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-globe"></i>
            <span class="fw-semibold mx-2">
              {{ "ValidIPAddress" | translate }} :
            </span>
            <span>{{ userProfile.validIPAddress }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-history"></i>
            <span class="fw-semibold mx-2">
              {{ "LastActiveIPAddress" | translate }} :
            </span>
            <span>{{ userProfile.lastActiveIPAddress }}</span>
          </li>
        </ul>

        <app-loading-panel *ngIf="loadingUser"></app-loading-panel>
      </div>
    </div>
  </div>
  <div class="mb-4 col-3">
    <div class="card animate__animated animate__fadeInDown animate__delay-3-8s">
      <div class="card-body">
        <small class="text-muted text-uppercase">
          {{ "DrugStoreInfo" | translate }}
        </small>

        <ul class="list-unstyled mb-4 mt-3">
          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-store"></i>
            <span class="fw-semibold mx-2">
              {{ "drugStoreName" | translate }} :
            </span>
            <span>{{ drugStoreProfile.title }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-id-card"></i>
            <span class="fw-semibold mx-2">
              {{ "DrugStoreNationalCode" | translate }} :
            </span>
            <span>{{ drugStoreProfile.nationalCode | dataType : "" }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-chart-line"></i>
            <span class="fw-semibold mx-2">
              {{ "DrugStoreEconomicalCode" | translate }} :
            </span>
            <span>{{ drugStoreProfile.economicalCode | dataType : "" }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-id-badge"></i>
            <span class="fw-semibold mx-2"> {{ "phaId" | translate }} : </span>
            <span>{{ drugStoreProfile.phaId | dataType : "" }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-phone"></i>
            <span class="fw-semibold mx-2"> {{ "phone" | translate }} : </span>
            <span>{{ drugStoreProfile.phone | dataType : "telephone" }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-fax"></i>
            <span class="fw-semibold mx-2"> {{ "fax" | translate }} : </span>
            <span>{{ drugStoreProfile.fax | dataType : "telephone" }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-envelope"></i>
            <span class="fw-semibold mx-2"> {{ "email" | translate }} : </span>
            <span>{{ drugStoreProfile.email }}</span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <i class="fas fa-map-pin"></i>
            <span class="fw-semibold mx-2">
              {{ "postalCode" | translate }} :
            </span>
            <span>{{ drugStoreProfile.postalCode }}</span>
          </li>

          <li class="d-flex align-items-center">
            <i class="fas fa-map"></i>
            <span class="fw-semibold mx-2">
              {{ "address" | translate }} :
            </span>
          </li>

          <li class="d-flex align-items-center mb-3">
            <span>{{ drugStoreProfile.address }}</span>
          </li>
        </ul>

        <app-loading-panel *ngIf="loadingDrugStore"></app-loading-panel>
      </div>
    </div>
  </div>
</div>
